import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase";
import { firestorePlugin } from 'vuefire'
import VueRouter from 'vue-router'
import UUID from 'vue-uuid';
import routes from './routes'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Buefy, {defaultIconPack: 'fas', defaultIconComponent: 'font-awesome-icon'})

Vue.use(VueRouter)
Vue.use(firestorePlugin)
Vue.use(UUID)

Vue.config.productionTip = false

const router = new VueRouter({routes});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  console.log('currentUser', currentUser);
  console.log('requiresAuth', requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else next();
});

String.prototype.truncate = function(max) {
  let re = this.match(new RegExp("^.{0," + max + "}[\\S]*"));
  let l = re[0].length;
  re = re[0].replace(/\s$/,'');
  if(l < this.length)
      re = re + " ...";
  return re;
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');